import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["src", "srcset"];
var _hoisted_2 = {
  class: "tw-text-22 tw-font-semibold tw-mb-0"
};
var _hoisted_3 = {
  key: 0,
  class: "price-reserved"
};
var _hoisted_4 = {
  key: 1,
  class: "price"
};
var _hoisted_5 = {
  class: "tw-text sm:tw-text-16 tw-font-regular tw-mt-10px tw-mb-5px"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  class: "tw-flex tw-items-center property-details tw-flex-wrap sm:tw-flex-nowrap tw-mt-10px tw-mb-5px"
};
var _hoisted_9 = {
  key: 0,
  class: "tw-inline-block tw-mr-2 energ-class tw-pr-10px"
};
var _hoisted_10 = {
  key: 1,
  class: "tw-mr-2 tw-inline-flex tw-items-center"
};
var _hoisted_11 = {
  class: "tw-bg-w-cultured tw-rounded-[5px] tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "tw-font-semibold"
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "tw-text-12"
}, [/*#__PURE__*/_createTextVNode("m"), /*#__PURE__*/_createElementVNode("sup", null, "2")], -1 /* HOISTED */);
var _hoisted_15 = {
  key: 2,
  class: "tw-mr-2 tw-inline-flex tw-items-center"
};
var _hoisted_16 = {
  class: "tw-bg-w-cultured tw-rounded-[5px] tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  key: 0,
  class: "tw-font-semibold"
};
var _hoisted_19 = {
  key: 1
};
var _hoisted_20 = {
  class: "tw-hidden sm:tw-block"
};
var _hoisted_21 = {
  key: 3,
  class: "tw-mr-2 tw-inline-flex tw-items-center"
};
var _hoisted_22 = {
  class: "tw-bg-w-cultured tw-rounded-[5px] tw-flex tw-items-center tw-justify-center tw-p-5px tw-mr-5px"
};
var _hoisted_23 = ["src"];
var _hoisted_24 = {
  key: 0,
  class: "tw-font-semibold"
};
var _hoisted_25 = {
  key: 1
};
var _hoisted_26 = {
  class: "tw-hidden sm:tw-block"
};
import BaseCard from "@vueEntry/UIKitComponents/BaseCard.vue";
import { formatInteger } from "@utils/NumberUtils";
import { redirect } from "@utils/RedirectUtils";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { computed } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'Insertion',
  props: {
    realEstate: {},
    vertical: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open-url"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var {
      cdn
    } = useCommonVars();
    //@ts-ignore
    var typology = computed(() => window["_typologyLabel"]);
    //@ts-ignore
    var rooms = computed(() => props.realEstate.rooms > 1 ? window["_roomsLabel"] : window["_roomLabel"]);
    //@ts-ignore
    var bathrooms = computed(() => props.realEstate.bathrooms > 1 ? window["_bathroomsLabel"] : window["_bathroomLabel"]);
    //@ts-ignore
    var reservedPrice = computed(() => window["_reservedPriceLabel"]);
    var sqM = computed(() => formatInteger(props.realEstate.sqM));
    var price = computed(() => formatInteger(props.realEstate.price ? props.realEstate.price : props.realEstate.priceRent));
    var openURL = () => {
      redirect({
        url: "".concat(window["_baseURL"], "/").concat(props.realEstate.id),
        blankPage: {
          lg: true
        }
      });
      emits("open-url");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BaseCard, {
        class: _normalizeClass(_ctx.$attrs['class']),
        type: _ctx.vertical && 'vertical',
        onClick: openURL
      }, {
        "card-image": _withCtx(() => [_ctx.realEstate.reImages[0] ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "tw-object-cover tw-h-full tw-w-full tw-bg-w-cultured",
          src: "".concat(_ctx.realEstate.reImages[0].images[2].storagePath),
          srcset: "".concat(_ctx.realEstate.reImages[0].images[1].storagePath, " 320w, ").concat(_ctx.realEstate.reImages[0].images[2].storagePath, " 640w, ").concat(_ctx.realEstate.reImages[0].images[2].storagePath, " 1280w"),
          sizes: "(max-width: 575px) 100vw, (min-width: 576px) and (max-width: 767px) 640px, 480px",
          alt: "real estate image"
        }, null, 8 /* PROPS */, _hoisted_1)) : _createCommentVNode("v-if", true)]),
        "card-description": _withCtx(() => [_createElementVNode("p", _hoisted_2, [_ctx.realEstate.reservedPrice ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(reservedPrice.value), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_4, " € " + _toDisplayString(price.value), 1 /* TEXT */))]), _createElementVNode("h4", _hoisted_5, [_ctx.realEstate.address !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(typology.value) + " in " + _toDisplayString(_ctx.realEstate.address) + ", " + _toDisplayString(_ctx.realEstate.cityName), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(typology.value) + ", " + _toDisplayString(_ctx.realEstate.cityName), 1 /* TEXT */))]), _createElementVNode("ul", _hoisted_8, [_ctx.realEstate.energyClass ? (_openBlock(), _createElementBlock("li", _hoisted_9, [_createElementVNode("span", {
          class: _normalizeClass("class-".concat(_ctx.realEstate.energyClassCss.toLowerCase()))
        }, _toDisplayString(_ctx.realEstate.energyClass), 3 /* TEXT, CLASS */)])) : _createCommentVNode("v-if", true), props.realEstate.sqM && props.realEstate.sqM > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
          src: "".concat(_unref(cdn), "/_ui/img/Ico/square-meter.svg"),
          height: "16",
          width: "16"
        }, null, 8 /* PROPS */, _hoisted_12)]), _createElementVNode("span", _hoisted_13, _toDisplayString(sqM.value), 1 /* TEXT */), _createTextVNode("  "), _hoisted_14])) : _createCommentVNode("v-if", true), _ctx.realEstate.rooms ? (_openBlock(), _createElementBlock("li", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
          src: "".concat(_unref(cdn), "/_ui/img/Ico/rooms.svg"),
          height: "16",
          width: "16"
        }, null, 8 /* PROPS */, _hoisted_17)]), _ctx.realEstate.rooms < 11 ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.realEstate.rooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_19, "10+")), _createTextVNode("  "), _createElementVNode("span", _hoisted_20, _toDisplayString(rooms.value), 1 /* TEXT */)])) : _createCommentVNode("v-if", true), _ctx.realEstate.bathrooms ? (_openBlock(), _createElementBlock("li", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
          src: "".concat(_unref(cdn), "/_ui/img/Ico/bath.svg"),
          height: "16",
          width: "16"
        }, null, 8 /* PROPS */, _hoisted_23)]), _ctx.realEstate.bathrooms < 6 ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.realEstate.bathrooms), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_25, "5+")), _createTextVNode("  "), _createElementVNode("span", _hoisted_26, _toDisplayString(bathrooms.value), 1 /* TEXT */), _createTextVNode("  ")])) : _createCommentVNode("v-if", true)])]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "type"]);
    };
  }
}));